(function () {
var $3015b282b063971c$exports = {};
window.scrollTo(0, 0);
const $3015b282b063971c$var$sidebarEl = document.getElementById("sidebar-wrapper");
const $3015b282b063971c$var$openBtnEl = document.getElementById("menu-open-link");
const $3015b282b063971c$var$closeBtnEl = document.getElementById("menu-close-link");
const $3015b282b063971c$var$scrollTo = (selector)=>{
    document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
    });
};
const $3015b282b063971c$var$toggleMenu = ()=>{
    $3015b282b063971c$var$sidebarEl.classList.toggle("active");
};
const $3015b282b063971c$var$isMenuOpen = ()=>$3015b282b063971c$var$sidebarEl.classList.contains("active");
const $3015b282b063971c$var$handleClick = (event)=>{
    const isOpenBtnClick = $3015b282b063971c$var$openBtnEl.contains(event.target);
    const isCloseBtnClick = $3015b282b063971c$var$closeBtnEl.contains(event.target);
    // Open and close side menu
    if (isOpenBtnClick || isCloseBtnClick) {
        event.preventDefault();
        $3015b282b063971c$var$toggleMenu();
        return;
    }
    const isSidebarClick = $3015b282b063971c$var$sidebarEl.contains(event.target);
    // Close side-menu on outside click when open
    if (!isSidebarClick && !isOpenBtnClick && $3015b282b063971c$var$isMenuOpen()) {
        $3015b282b063971c$var$toggleMenu();
        return;
    }
    let targetId = null;
    let currentNode = event.target;
    while(currentNode && currentNode.getAttribute){
        targetId = currentNode.getAttribute("data-target");
        if (targetId) break;
        currentNode = currentNode.parentNode;
    }
    if (targetId) {
        event.preventDefault();
        $3015b282b063971c$var$scrollTo(`#${targetId}`);
        if ($3015b282b063971c$var$isMenuOpen()) $3015b282b063971c$var$toggleMenu();
    }
};
document.addEventListener("click", $3015b282b063971c$var$handleClick);

})();
//# sourceMappingURL=index.a848ea9d.js.map
